var _excluded = ["className", "isExternal"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef, omitThemingProps, useMultiStyleConfig } from '../../system';
import { cx, __DEV__ } from '../../utils';
import * as React from 'react';
/**
 * Links are accessible elements used primarily for navigation.
 *
 * It integrates well with other routing libraries like
 * React Router, Reach Router and Next.js Link.
 *
 * @example
 *
 * ```jsx
 * <Link as={ReactRouterLink} to="/home">Home</Link>
 * ```
 */
export var Link = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('Link', props);
  var _omitThemingProps = omitThemingProps(props),
    {
      className,
      isExternal
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  return /*#__PURE__*/React.createElement(tqc.a, _extends({
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noopener noreferrer' : undefined,
    ref: ref,
    className: cx('tqc-link', className)
  }, rest, {
    __css: styles.button
  }));
});
if (__DEV__) {
  Link.displayName = 'Link';
}